import { Component, HostListener, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common'
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Router } from '@angular/router';
import { APIService } from '../fleet-management/backend-service/backend-service';
import { environment } from '../../environments/environment';
import { SharedService } from '../share-data/shared.service';
import { GlobalVariablesService } from '../global.service';
import { NotificationService } from '../shared/services/notification.service';
import { LoadingService } from '../services/loading.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../fleet-management/transport-management/confirm-dialog/confirm-dialog.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-user-management',
  imports: [
    ReactiveFormsModule,
    FormsModule,
    MatCheckboxModule,
    MatInputModule,
    CommonModule,
    MatChipsModule,
    MatSelectModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatIconModule,
    MatRadioModule,
    MatProgressSpinnerModule
  ],
  templateUrl: './user-management.component.html',
  styleUrl: './user-management.component.scss'
})
export class UserManagementComponent implements OnDestroy {
  selectedUserId: string | null = null;
  dropdownPosition = { top: '0px', right: '0px' };
  searchText: string = '';
  datas: any[] = [];
  currentPage: number = 1;
  totalPages: number = 1;
  pageSize: number = 10;
  pages: number[] = [];
  userList: any[] = [];
  isLoading: boolean = false;
  private loadingSubscription: Subscription;

  constructor(private router: Router, private apiService: APIService, private sharedService: SharedService, private globalVariable: GlobalVariablesService,
    private notification: NotificationService, public loadingService: LoadingService,
    private dialog: MatDialog) {
    this.loadingSubscription = this.loadingService.isLoading$.subscribe(loading => this.isLoading = loading);
  }

  ngOnInit() {
    console.log("Role: ", this.globalVariable.SETTING_USER_ROLES)
    this.getUserList();
  }
  getUserList(page: number = 1) {
    this.datas = [];
    let loginData = JSON.parse(localStorage.getItem('loginData')!)
    console.log("LoginData: ", loginData)
    this.apiService.get(`/api/users?page=${page}&limit=${this.pageSize}`, loginData.token).subscribe({
      next: (response) => {
        console.log('Status:', response.status);
        console.log('/api/user/list' + ',\n' + 'User_List_Response:', response.body);
        if (response.status === 200) {
          this.userList = response.body.users;
          response.body.users.forEach((data: { [x: string]: any; }) => {
            try {
              // this.datas = response.body.users;
              this.datas.push({
                photo: environment.imageUrl + data['profilePicture'],
                khmerName: `${data['khmerName'] ? data['khmerName'] : ''}`,
                englishName: `${data['englishName'] ? data['englishName'] : ''}`,
                email: data['email'],
                roleCode: data['roleCode'],
                id: data['id']
              })
              this.totalPages = response.body.pagination.totalPages;
              this.pages = Array(this.totalPages).fill(0).map((_, i) => i + 1);
              this.currentPage = page;
              console.log("this.datas: ", this.datas)
            } catch (error) {

            }
          });
        }
        else {
          console.log("Hey you")
        }
      },
      error: (error) => {
        console.error('Error status:', error.status);
        console.error('Error message:', error.message);
      }
    });
  }
  get pagedOrders() {
    const start = (this.currentPage - 1) * this.pageSize;
    return this.filteredOrders.slice(start, start + this.pageSize);
  }
  filterUserRole(roleCode: string): string {
    const role = this.globalVariable.SETTING_USER_ROLES?.find((role: any) => role.roleCode === roleCode);
    return role ? role.name : 'Unknown Role';
  }
  addNewCustomer() {
    this.router.navigate(['/home/user-management/register']);
  }
  get filteredOrders() {
    return this.datas.filter(data =>
      data.khmerName.toLowerCase().includes(this.searchText.toLowerCase()) ||
      data.englishName.toLowerCase().includes(this.searchText.toLowerCase()) ||
      data.email.toLowerCase().includes(this.searchText.toLowerCase()) ||
      this.filterUserRole(data.roleCode).toLowerCase().includes(this.searchText.toLowerCase())
    );
  }

  editUser(data: any, event: MouseEvent) {
    console.log("Selected Id: ", data.id)
    if (this.selectedUserId === data.id) {
      this.selectedUserId = null;
    } else {
      const btn = event.currentTarget as HTMLElement;
      const rect = btn.getBoundingClientRect();
      this.dropdownPosition = {
        top: `${rect.bottom + 4}px`,
        right: `${Math.max(window.innerWidth - rect.right, 8)}px`,
      };
      this.selectedUserId = data.id;
    }
  }
  onEdit(data: any) {
    const role = this.userList.find((role: any) => role.id === data.id);
    this.selectedUserId = null;
    const editData = {...role, url: environment.imageUrl};
    this.sharedService.setData(editData);
    sessionStorage.setItem('userEditData', JSON.stringify(editData));
    this.router.navigate(
      ['/home/user-management/register/:id'],
      { queryParams: { isEdit: true } }
    );
  }

  onDelete(data: any) {
    this.selectedUserId = null;
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '420px',
      data: { plateNumber: data.englishName, title: 'Delete User', confirmLabel: 'Delete', message: 'Are you sure you want to delete user' }
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.deleteUser(data);
      }
    });
  }
  deleteUser(data: any) {
    let loginData = JSON.parse(localStorage.getItem('loginData')!)
    this.apiService.delete('/api/users/' + data.id, loginData.token).subscribe({
      next: (response) => {
        console.log('Status:', response.status);
        console.log('/api/users/delete' + ',\n' + 'User_Delete_Response:', response);
        if (response.status === 200) {
          this.datas = response.body;
        }
        else {
          console.log("Hey you")
        }
        this.notification.success(response.message || 'Operation completed successfully');
        this.getUserList();
      },
      error: (error) => {
        console.error('Error status:', error.status);
        console.error('Error message:', error.message);
      }
    });
  }
  @HostListener('document:click', ['$event'])
  handleClickOutside(event: MouseEvent) {
    const target = event.target as HTMLElement;

    // Only close the dropdown if clicked outside any dropdown-related button or menu
    if (!target.closest('.btn-icon-action') && !target.closest('.dropdown-menu')) {
      this.selectedUserId = null;
    }
  }

  ngOnDestroy() {
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
    }
  }
}
